import { Component } from '@angular/core';
import { ConfigService } from '../../Services/ConfigService';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'TrialPopUp',
	templateUrl: 'TrialPopUp.html',
	moduleId: module.id
})
export class TrialPopUpComponent {

	expire: string = '';
	first: boolean = false;

	constructor(public configData: ConfigService,
		public activeModal: NgbActiveModal) {
	}
	closePopUp() {
		this.activeModal.close();
	}
}